/* tslint:disable */
/* eslint-disable */
/**
 * SONeu.WebApi | v1
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


import * as runtime from '../runtime';
import type {
  ChangeHistorySection,
  ClientChangeHistoryEntryResponse,
  ClientChangeInfoResponse,
  ProblemDetails,
} from '../models/index';
import {
    ChangeHistorySectionFromJSON,
    ChangeHistorySectionToJSON,
    ClientChangeHistoryEntryResponseFromJSON,
    ClientChangeHistoryEntryResponseToJSON,
    ClientChangeInfoResponseFromJSON,
    ClientChangeInfoResponseToJSON,
    ProblemDetailsFromJSON,
    ProblemDetailsToJSON,
} from '../models/index';

export interface GetClientChangeHistoryRequest {
    clientId: string;
    section: ChangeHistorySection;
    entryId?: string;
}

export interface GetClientChangeInfoRequest {
    clientId: string;
    section: ChangeHistorySection;
    entryId?: string;
}

/**
 * ClientChangeHistoryApi - interface
 * 
 * @export
 * @interface ClientChangeHistoryApiInterface
 */
export interface ClientChangeHistoryApiInterface {
    /**
     * 
     * @param {string} clientId 
     * @param {ChangeHistorySection} section 
     * @param {string} [entryId] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ClientChangeHistoryApiInterface
     */
    getClientChangeHistoryRaw(requestParameters: GetClientChangeHistoryRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<Array<ClientChangeHistoryEntryResponse>>>;

    /**
     */
    getClientChangeHistory(requestParameters: GetClientChangeHistoryRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<Array<ClientChangeHistoryEntryResponse>>;

    /**
     * 
     * @param {string} clientId 
     * @param {ChangeHistorySection} section 
     * @param {string} [entryId] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ClientChangeHistoryApiInterface
     */
    getClientChangeInfoRaw(requestParameters: GetClientChangeInfoRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<ClientChangeInfoResponse>>;

    /**
     */
    getClientChangeInfo(requestParameters: GetClientChangeInfoRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<ClientChangeInfoResponse>;

}

/**
 * 
 */
export class ClientChangeHistoryApi extends runtime.BaseAPI implements ClientChangeHistoryApiInterface {

    /**
     */
    async getClientChangeHistoryRaw(requestParameters: GetClientChangeHistoryRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<Array<ClientChangeHistoryEntryResponse>>> {
        if (requestParameters['clientId'] == null) {
            throw new runtime.RequiredError(
                'clientId',
                'Required parameter "clientId" was null or undefined when calling getClientChangeHistory().'
            );
        }

        if (requestParameters['section'] == null) {
            throw new runtime.RequiredError(
                'section',
                'Required parameter "section" was null or undefined when calling getClientChangeHistory().'
            );
        }

        const queryParameters: any = {};

        if (requestParameters['section'] != null) {
            queryParameters['section'] = requestParameters['section'];
        }

        if (requestParameters['entryId'] != null) {
            queryParameters['entryId'] = requestParameters['entryId'];
        }

        const headerParameters: runtime.HTTPHeaders = {};


        let urlPath = `/api/clients/{clientId}/change-history`;
        urlPath = urlPath.replace(`{${"clientId"}}`, encodeURIComponent(String(requestParameters['clientId'])));

        const response = await this.request({
            path: urlPath,
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => jsonValue.map(ClientChangeHistoryEntryResponseFromJSON));
    }

    /**
     */
    async getClientChangeHistory(requestParameters: GetClientChangeHistoryRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<Array<ClientChangeHistoryEntryResponse>> {
        const response = await this.getClientChangeHistoryRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     */
    async getClientChangeInfoRaw(requestParameters: GetClientChangeInfoRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<ClientChangeInfoResponse>> {
        if (requestParameters['clientId'] == null) {
            throw new runtime.RequiredError(
                'clientId',
                'Required parameter "clientId" was null or undefined when calling getClientChangeInfo().'
            );
        }

        if (requestParameters['section'] == null) {
            throw new runtime.RequiredError(
                'section',
                'Required parameter "section" was null or undefined when calling getClientChangeInfo().'
            );
        }

        const queryParameters: any = {};

        if (requestParameters['section'] != null) {
            queryParameters['section'] = requestParameters['section'];
        }

        if (requestParameters['entryId'] != null) {
            queryParameters['entryId'] = requestParameters['entryId'];
        }

        const headerParameters: runtime.HTTPHeaders = {};


        let urlPath = `/api/clients/{clientId}/change-info`;
        urlPath = urlPath.replace(`{${"clientId"}}`, encodeURIComponent(String(requestParameters['clientId'])));

        const response = await this.request({
            path: urlPath,
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => ClientChangeInfoResponseFromJSON(jsonValue));
    }

    /**
     */
    async getClientChangeInfo(requestParameters: GetClientChangeInfoRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<ClientChangeInfoResponse> {
        const response = await this.getClientChangeInfoRaw(requestParameters, initOverrides);
        return await response.value();
    }

}
